











import MediaLibrary from './components/media/MediaLibrary.vue'
import { defineComponent } from '@vue/composition-api'
import { useStore as useTextbookStore } from '@/shared/state-management/textbookStore'

export default defineComponent({
  name: 'MediaLibraryTemplate',
  components: {
    MediaLibrary,
  },
  setup() {
    const { activeTextbook } = useTextbookStore().getters

    return {
      activeTextbook,
    }
  },
})
